import React, { Component } from 'react'

class Screen5A extends Component {

  render() {

    const { entry, addEntry, language, t } = this.props

    return (
      <main>
        <h3>{t(language, 'hateCrimeDetails')}</h3>
        <label>{t(language, 'victim')}
          <input type="text" value={entry.victim} onChange={(e) => addEntry('victim', null, e)} />
        </label>
        <p className="hint">{language === 'hr' ? 'Navedite primjerice spol žrtve, stas, izgled, eventualna vidljiva i uočljiva obilježja – pripadnost drugoj rasi, vjerska obilježja i sl.' : 'For example, specify the gender of the victim, stature, appearance, any visible and observable characteristics - belonging to another race, religious characteristics, etc.'}</p>
        <label>{t(language, 'crime')}
          <input type="text" value={entry.crime} onChange={(e) => addEntry('crime', null, e)} />
        </label>
        <p className="hint">{language === 'hr' ? 'Ne trebate unositi zakonske kvalifikacije. Navedite primjerice gdje ste bili i što ste radili u trenutku događaja, kako vam je / su napadač/i prišli, je li vam nešto rečeno, kojim tonom vam je rečeno i što se dalje desilo.' : 'You do not need to enter legal definitions. For example, specify where you were and what you were doing at the time of the event, how the attacker(s) approached you, whether something was said to you, what tone it was said in, and what happened next.'}</p>
        <label>{t(language, 'attacker')}
          <input type="text" value={entry.attacker} onChange={(e) => addEntry('attacker', null, e)} />
        </label>
        <p className="hint">{language === 'hr' ? 'Navedite primjerice spol napadača, stas, izgled, eventualna vidljiva i uočljiva obilježja – od fizičkih do pripadnosti određenim grupacijama, vjerska obilježja i sl.' : 'For example, specify the gender of the attacker, stature, appearance, any visible and observable characteristics - from physical to belonging to certain groups, religious characteristics, etc.'}</p>
      </main>
    );
  }
}

export default Screen5A;
